import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useTranslation } from 'react-i18next';
import { Div } from '../../../../layouts';
import { SlideGroupContext } from '../../../../components/SlideManager';
import { FieldType } from '../../../../models';

export const FieldHeaderPrisma = ({ extraTracking, textKey, hasLocationInput, children }) => {
    const { t } = useTranslation();
    const text = t(textKey);
    const context = React.useContext(SlideGroupContext);
    const currentSlideGroup = context.getCurrent();
    const shouldShowBack = currentSlideGroup.history.length > 1;

    const onClickHeaderCross = () => {
        currentSlideGroup.active === FieldType.DATE && extraTracking();
        context.close();
    };

    const classNames = className({
        'odf-flex-container-row odf-flex-container-nogutter odf-flex-container-justify-between': true,
        'odf-space-inner-bottom-m': hasLocationInput,
    });

    return (
        <Div
            className="odf-header-mobile-prisma odf-header-mobile-shadow odf-space-inner-top-l
                odf-space-outer-bottom-s prisma-responsive-space-horizontal"
            height={hasLocationInput ? 'auto' : null}
            paddingBottom={hasLocationInput ? 10 : null}
        >
            <div className={classNames}>
                <Div
                    className="odf-flex-item"
                    onClick={context.prev}
                    visibility={shouldShowBack ? 'visible' : 'hidden'}
                >
                    <span className="odf-icon odf-icon-2xl odf-icon-arrow-left-tail odf-icon-bidi odf-header-mobile-icon-color" />
                </Div>
                <div className="odf-flex-item">
                    <span className="prisma-lightbox-header-text odf-text-neutral-700">{text}</span>
                </div>
                <div
                    className="odf-flex-item odf-flex-item-sm"
                    onClick={onClickHeaderCross}
                >
                    <span className="odf-icon odf-icon-2xl odf-icon-cross-light odf-header-mobile-icon-color" />
                </div>
            </div>
            { hasLocationInput && (
                children
            )}
        </Div>
    );
};

FieldHeaderPrisma.propTypes = {
    extraTracking: PropTypes.func,
    textKey: PropTypes.string,
    children: PropTypes.node,
    hasLocationInput: PropTypes.bool,
};

FieldHeaderPrisma.defaultProps = {
    extraTracking: ()=>{},
    textKey: '',
    hasLocationInput: false,
    children: null,
};
